import React, { useMemo } from 'react';
import Column from 'src/components/10-atoms/layout/Column';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import sortBy from 'src/utils/array/sortBy';
import styleUtils from 'src/utils/styles';
import EFTimelineItem from './EFTimelineItem';
const EFTimeline = ({ question, style, ...columnProps }) => {
    const [{ styles }] = useTheme(stylesGenerator);
    const feedbacks = useMemo(() => {
        const allFeedbacks = [
            ...question.duplicates,
            {
                ...question,
            },
        ];
        return sortBy(allFeedbacks, item => item.questionPaper?.data.dateNL ?? '', 'desc').map((item, i) => ({
            isCurrent: question.questionPaper?.data.dateNL === item.questionPaper?.data.dateNL,
            questionPaper: item.questionPaper,
            examinersFeedback: item.examinersFeedback,
            isLast: i === allFeedbacks.length - 1,
            isFirst: i === 0,
            question: item,
        }));
    }, [question.duplicates]);
    return (React.createElement(Column, { style: [styles.container, style], ...columnProps },
        React.createElement(Column, { style: styleUtils.pagePadding }, feedbacks.map((feedback, i) => (React.createElement(EFTimelineItem, { key: i, feedback: feedback }))))));
};
const stylesGenerator = createThemedStyle(({ theme }) => ({
    container: {
        paddingTop: theme.spacing.standard.sm,
    },
}));
export default EFTimeline;
